import Vue from "@/helper/initVue";
import store from "@/store";

import MeterReadingComponent from "@/features/meter-reading-component";
import { MeterReadingComponentConfig } from "@/features/meter-reading-component/components";

export const initMeterReadingComponentRoute = () => {
  const el = document.getElementById("meter-reading-component");

  if (!el) {
    return;
  }

  try {
    const dataConfig = el.getAttribute("data-config");

    const parsedConfig: MeterReadingComponentConfig = JSON.parse(
      dataConfig ? dataConfig : "{}"
    );

    new Vue({
      el,
      store: store.original, // Inject the classic Vuex store
      render: (h) =>
        h(MeterReadingComponent, {
          props: {
            config: parsedConfig,
          },
        }),
    });
  } catch (err) {
    console.error('Failed to load module "MeterReadingComponent"');
  }
};

initMeterReadingComponentRoute();
